import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store/store'
import 'normalize.css'
import VeeValidate, { Validator } from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import axios from 'axios'
import VueAxios from 'vue-axios'

const dictionary = {
  custom: {
    credit_sum: {
      required: 'Вы не ввели сумму',
      min_value: 'Сумма от 10 000 тг. до 1 500 000 тг.',
      max_value: 'Сумма от 10 000 тг. до 1 500 000 тг.'
    },
    client_name: {
      required: () => 'Вы не заполнили поле',
      alpha_spaces: () => 'Данное поле может содержать только буквенные символы',
      min: () => 'Минимальное количество символов равно 3',
      max: () => 'Максимальное количество символов равно 128'
    },
    id_num: {
      required: () => 'Вы не заполнили поле',
      length: () => 'Неверно введен ИИН',
      numeric: () => 'Данное поле может содержать только цифровые символы'
    },
    phone_num: {
      required: () => 'Вы не заполнили поле',
      length: () => 'Неверно введен номер телефона',
      numeric: () => 'Данное поле может содержать только цифровые символы'
    }
  }
}

Vue.use(Vuex)
Vue.use(VeeValidate)
Vue.use(VueTheMask)
Vue.use(VueAxios, axios)

Validator.localize('en', dictionary)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
